import React, { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsCompleted,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const CompletedStatus = ({ userPermission, query = "" }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(
    (page = 1, size = limit) => {
      fetchStatuses(
        "COMPLETED",         // показываем только COMPLETED
        "ORDER_INSTALLED",   // или нужный вам статус
        query,
        setLeads,
        setIsLoading,
        setTotalCount,
        page,
        size
      ).then(() => {
        setCurrentPage(page);
        setLimit(size);
      });
    },
    [query, limit]
  );

  useEffect(() => {
    loadData(1, limit);
  }, [query, loadData, limit]);

  const handlePageChange = (page, size) => {
    loadData(page, size);
  };

  return (
    <>
      <Table
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsCompleted}
        dataSource={getOrderStatusDataSource(leads, loadData)}
        pagination={false}
        expandable={{
          expandedRowRender: record => (
            <OrderStatusFullInfo data={record.data} userPermission={userPermission} />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          showSizeChanger
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default CompletedStatus;
